<template>
    <div class="create-account__container">
        <div class="create-account__accept-terms redesign-checkbox redesign-checkbox--margin-right" :id="fullFormIdentifier + '-create-account-errors'">
            <div class="create-account__pop-up-container">
                <input v-model="createAccount" @click="togglePasswordSection" class="redesign-checkbox__input" type="checkbox" name="create-account" :id="fullFormIdentifier + '-create-account'" :value="true"/>
                <label class="redesign-checkbox__label" :for="fullFormIdentifier + '-create-account'">
                    <span class="redesign-checkbox__span"></span>
                </label>
                <span @click="togglePasswordSection" class="create-account__link">Yes, I would like to create an account</span>
                <div class="create-account__icon-container">
                    <div @click="triggerModal" class="create-account__icon" ref="icon"></div>
                    <div @click="triggerModal" class="create-account__pop-up-container-icon" ref="popup">
                        <CreateAccountPopOut :open="openModal" @closeModal="triggerModal" :formType="formType"></CreateAccountPopOut>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="createAccount === true" class="create-account__set-password">
            <h2 class="create-account__h2">Set your password:</h2>
            <div class="create-account__password-section">
                <div class="create-account__passwords">
                        <div class="login__password-container">
                            <input class="form-element__input"
                                :type="getInputType('password')"
                                name="password"
                                id="password"
                                :placeholder="createAccount ? 'Create a password*' : 'Password*'"
                                data-validate="password"
                                data-validate-message="Please enter a password">
                            <div class="login__toggle-password" @click="togglePasswordVisibility('password')">
                                <img :src="getEyeIcon('password')" alt="Toggle Password" class="login__eye-icon" id="eye-icon">
                            </div>
                        </div>
                        <div class="login__password-container">
                            <input class="form-element__input"
                                :type="getInputType('confirm')"
                                name="password_confirmation"
                                id="password-confirmation"
                                placeholder="Repeat password*"
                                data-validate='confirm_password'
                                data-validate-confirm-password-target="#password">
                            <div class="login__toggle-password" @click="togglePasswordVisibility('confirm')">
                                <img :src="getEyeIcon('confirm')" alt="Toggle Password" class="login__eye-icon" id="eye-icon-confirm">
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import CreateAccountPopOut from "../CreateAccountPopOut.vue"
export default {
    components: {
        CreateAccountPopOut,
    },
    props: {
        formIdentifier: {
            type: String,
            default: "form",
        },
        privacyTermsLink: {
            type: String,
            default: "/terms-and-conditions",
        },
        formType:{
            type: String,
            default: 'osb',
        },
    },
    data() {
        return {
            createAccountPreference: "",
            openModal: false,
            passwordInputType: 'password',
            confirmPasswordInputType: 'password',
            eyeIconOpen: '/images/my-account/eye-open.svg',
            eyeIconClosed: '/images/my-account/eye-closed.svg',
            createAccount: false,
            containerTop: 0,
            containerLeft: 0,
            createAccount: false,
        };
    },
    methods: {
        togglePasswordSection(){
            this.createAccount = !this.createAccount;
            this.$emit('updateForm');
        },
        triggerModal() {
            this.openModal = !this.openModal;
            if (this.openModal) {
                document.addEventListener('click', this.handleClickOutside);
            } else {
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        handleClickOutside(event) {
            const icon = this.$refs.icon;
            const popup = this.$refs.popup;

            if (popup && !popup.contains(event.target) && icon && !icon.contains(event.target)) {
                this.openModal = false;
                document.removeEventListener('click', this.handleClickOutside);
            }
        },
        togglePasswordVisibility(inputId) {
            if (this.getInputType(inputId) === 'password') {
                this.setInputType(inputId, 'text');
            } else {
                this.setInputType(inputId, 'password');
            }
        },
        getInputType(inputId) {
            return inputId === 'password' ? this.passwordInputType : this.confirmPasswordInputType;
        },
        setInputType(inputId, type) {
            if (inputId === 'password') {
                this.passwordInputType = type;
            } else {
                this.confirmPasswordInputType = type;
            }
        },
        getEyeIcon(inputId) {
            return this.getInputType(inputId) === 'password' ? this.eyeIconClosed : this.eyeIconOpen;
        }
    },
    computed: {
        fullFormIdentifier() {
            return this.formIdentifier + "-" + this._uid;
        },
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside);
    }
};
</script>